module.exports = __webpack_public_path__ + "static/img/20010 (4).f9f9dc2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20010 (4).webp
// module id = hbXy
// module chunks = 14